import { logger } from "@/utils/logger";

// Platinum Audience ID constant
export const PLATINUM_AUDIENCE_ID = "5f376cf0-4deb-4697-b906-d21cbf10fd77";

// Function to determine environment
const getEnvironment = () => {
  const hostname = window.location.hostname;

  if (hostname.includes("staging.lexi.tips")) {
    return "dev";
  } else if (hostname.includes("lexi.tips") && !hostname.includes("staging") && !hostname.includes("dev")) {
    return "prod";
  }

  // Default to dev for localhost and any other domains
  return "dev";
};

// Base URLs with environment placeholder
const CREATE_CONTACT_BASE_URL = "https://australia-southeast1-lexi-458204.cloudfunctions.net/lexi-{env}-create-contact";
const GET_CONTACT_BASE_URL = "https://australia-southeast1-lexi-458204.cloudfunctions.net/lexi-{env}-get-contact";

// Get the URLs with the correct environment
const getCreateContactUrl = () => CREATE_CONTACT_BASE_URL.replace("{env}", getEnvironment());
const getGetContactUrl = () => GET_CONTACT_BASE_URL.replace("{env}", getEnvironment());

/**
 * Create a new contact in Resend
 */
export const createContact = async ({ email, audienceId, firstName, lastName, phoneNumber }) => {
  try {
    logger.log("Creating contact in Resend:", email);

    if (!email || !audienceId) {
      throw new Error("Email and audienceId are required");
    }

    const payload = {
      email,
      audienceId,
      ...(firstName && { firstName }),
      ...(lastName && { lastName }),
      ...(phoneNumber && { phoneNumber }),
    };

    const response = await fetch(getCreateContactUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      logger.error("Resend API error:", errorData);
      throw new Error(
        errorData.message || errorData.error || "Failed to create contact"
      );
    }

    const responseData = await response.json();
    logger.log("Contact created successfully:", responseData);

    return {
      success: true,
      data: responseData.data,
    };
  } catch (error) {
    logger.error("Error creating contact:", error);
    throw error;
  }
};

/**
 * Get a contact from Resend by email
 */
export const getContact = async (email) => {
  try {
    logger.log("Getting contact from Resend:", email);

    if (!email) {
      throw new Error("Email is required");
    }

    const payload = {
      email,
    };

    const response = await fetch(getGetContactUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      logger.error("Resend API error:", errorData);
      throw new Error(
        errorData.message || errorData.error || "Failed to get contact"
      );
    }

    const responseData = await response.json();
    
    // Check if the response contains an error (contact not found)
    if (responseData.data && responseData.data.error) {
      logger.log("Contact not found in Resend:", email);
      return {
        success: true,
        found: false,
        data: null,
      };
    }

    logger.log("Contact retrieved successfully:", responseData);

    return {
      success: true,
      found: true,
      data: responseData.data,
    };
  } catch (error) {
    logger.error("Error getting contact:", error);
    throw error;
  }
};

